import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../http-client/http-client.service';
import { SchoolData } from '../../models/school-data/schooldata';
import { Service } from '../service';

@Injectable()
export class SchoolDataService extends Service {

    public schoolData: SchoolData[];
    public schoolDataObject: any;

    constructor(private http: HttpClientService) {
        super();
        this.schoolData = [];
        this.schoolDataObject = {};
    }

    public getAll(): Observable<SchoolData[]> {
        if (!!this.schoolData && this.schoolData.length > 0) {
            return Observable.create((observer: Subscriber<SchoolData[]>) => {
                observer.next(this.schoolData);
                observer.complete();
            });
        }
        const url = 'schooldata/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.schoolData = r.Result;
                this.schoolDataObject = this.schoolData.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('schoolDataService > getAll > response', r);
            }
            return this.schoolData;
        }).catch(this.handleError);
    }

    public get(): Observable<SchoolData> {
        const url = 'schooldata/get';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.schoolData = r.Result;
            } else {
                console.error('schooldataService > get > response', r);
            }
            return r.Result;
        }).catch(this.handleError);
    }

    public getData(): Observable<any> {
        const url = 'schooldata/data';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.schoolData = r.Result;
            } else {
                console.error('schooldataService > data > response', r);
            }
            return r.Result;
        }).catch(this.handleError);
    }

    public add(data: any) {
        const url = 'schooldata/add';
        return this.http.post(url, data).map(response => response.json())
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/school-data/school-data.service.ts